import { render, staticRenderFns } from "./document-delete-modal.vue?vue&type=template&id=d593135e&scoped=true"
import script from "./document-delete-modal.vue?vue&type=script&lang=js"
export * from "./document-delete-modal.vue?vue&type=script&lang=js"
import style0 from "./document-delete-modal.vue?vue&type=style&index=0&id=d593135e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d593135e",
  null
  
)

export default component.exports